import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "toggle"]

  connect() {
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.handleResize)
    document.body.style.overflow = ""
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
    document.body.style.overflow = ""
  }

  toggleMobile() {
    const isOpen = !this.panelTarget.classList.contains("-translate-x-full")
    
    this.panelTarget.classList.toggle("-translate-x-full")
    
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.toggle("hidden")
    }
    
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", !isOpen)
    }
    
    document.body.style.overflow = isOpen ? "" : "hidden"
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full")
    
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden")
    }
    
    document.body.style.overflow = ""
    
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", false)
    }
  }

  handleResize() {
    if (window.innerWidth >= 1024) {
      this.close()
    }
  }
}